export default "__VITE_ASSET__DGPVfqht__"